import {Vacation} from '../model/vacation';

export class VacationAndBreak{
  vacations : Vacation[] = [];
  pauses : Vacation[]= [];
}



// WEBPACK FOOTER //
// ./src/app/modules/vacationAndBreak.ts